// src/organisms/OrgChart/OrgChartD3.jsx
import React, { useEffect, useRef, useState } from "react";
import { OrgChart } from "d3-org-chart";
import OrgChartNode from "../../atoms/OrgChart/OrgChartNode";

const OrgChartD3 = ({ data }) => {
	const chartRef = useRef(null);
	const chart = useRef(null);
	const [searchTerm, setSearchTerm] = useState("");

const filterChart = () => {
    if (!chart.current || !data) return;

    const newData = data.map((user) => ({
        ...user,
        id: String(user.actualNode),
        parentNodeId: user.parentNode ? String(user.parentNode) : undefined,
        _expanded: false,
        _highlighted: false,
    }));

    let foundNodes = [];
    newData.forEach((d) => {
        const text = `${d.name} ${d.email || ""}`.toLowerCase();
        if (searchTerm && text.includes(searchTerm.toLowerCase())) {
            d._highlighted = true;
            d._expanded = true;
            foundNodes.push(d.id);  // <-- usa d.id (que es actualNode mapeado)
        }
    });

    chart.current
        .data(newData)
        .setCentered(foundNodes[0] ? foundNodes : "1")
        .render();
};

useEffect(() => {
    if (!data) return;

    const mappedData = data.map((user) => ({
        ...user,
        id: String(user.actualNode),
        parentNodeId: user.parentNode ? String(user.parentNode) : undefined,
    }));

    // Fix: eliminar referencias a padres que no existen
    const ids = new Set(mappedData.map((d) => d.id));
    const orphans = mappedData.filter(
        (d) => d.parentNodeId && !ids.has(d.parentNodeId)
    );
    if (orphans.length > 0) {
        console.warn("Nodos huérfanos detectados (se corregirán):", orphans.map(o => o.name));
    }

    const cleanData = mappedData.map((d) => ({
        ...d,
        // Si el padre no existe, lo convierte en hijo del nodo raíz (id "1")
        parentNodeId:
            d.parentNodeId && !ids.has(d.parentNodeId)
                ? "1"
                : d.parentNodeId,
    }));

    // Verificación final
    const roots = cleanData.filter((d) => !d.parentNodeId);
    console.log("Raíces:", roots.length, roots.map(r => r.name));

    if (!chart.current) {
        chart.current = new OrgChart()
            .container(chartRef.current)
            .data(cleanData)         // <-- cleanData
            .nodeHeight(() => 220)
            .nodeWidth(() => 300)
            .childrenMargin(() => 50)
            .compactMarginBetween(() => 25)
            .compact(false)
            .layout("top")
            .nodeContent((node) => OrgChartNode(node))
            .onNodeClick((d) => {
                d._expanded = !d._expanded;
                chart.current.render();
            })
            .render();
    } else {
        chart.current.data(cleanData).render();  // <-- cleanData aquí también
    }
}, [data]);

	return (
		<div ref={chartRef} className="w-full h-[100vh] overflow-auto">
			<div className="flex gap-2 p-2">
				<input
					type="text"
					placeholder="Buscar por nombre, email, extensión"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter") filterChart();
					}}
					className="px-2 py-1 border border-gray-300 rounded text-sm w-64"
				/>

				<button
					onClick={() => chart.current.compact(false).render().fit()}
					className="px-3 py-1 text-xs bg-[#00447b] text-white rounded hover:bg-[#003366] transition-colors"
				>
					Horizontal
				</button>
				<button
					onClick={() => chart.current.compact(true).render().fit()}
					className="px-3 py-1 text-xs bg-[#e11244] text-white rounded hover:bg-[#c0103a] transition-colors"
				>
					Compacto
				</button>
			</div>
		</div>
	);
};

export default OrgChartD3;
 